import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";

import { Controller, useForm } from "react-hook-form";
import Select from "react-select";
import Gray_Btn from "../../../../../../../common/common_btn/gray_btn/Gray_Btn";
import Black_Submit_Btn from "../../../../../../../common/common_btn/black_submit_btn/Black_Submit_Btn";
import Success_Toster from "../../../../../../../common/common_modal/success_toster/Success_Toster";
import { useSelector } from "react-redux";
import { FixIDS } from "../../../../../../../utils/fixIDS";

const Filter = ({ setShow, setSearchParams, reportgenerate }) => {
  const {
    register,
    handleSubmit,
    control,
    reset,
    formState: { errors },
    setError,
  } = useForm();

  const permissions = useSelector((state) => state.auth.permissions);

  const haveDownloadPermission = permissions?.includes(
    FixIDS.risk_and_opportunity_report.Report_Download,
  );

  const countries = [
    { label: "India", value: "1" },
    { label: "USA", value: "2" },
    { label: "UK", value: "3" },
  ];

  const [success, setSuccess] = useState(false);
  // ⏱ auto hide toaster after 3 sec
  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => {
        setSuccess(false);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [success]);

  const all_management_system_required_status = useSelector(
    (state) => state.common.all_management_system_required_status,
  );

  const onSubmit = (data) => {
    setSearchParams(data);
  };
  return (
    <section className="Sample_Report_Filter">
      <div className="row me-0 ms-0">
        <div className="col-lg-10">
          <div className="common_filter_div">
            <Form className="form_div" onSubmit={handleSubmit(onSubmit)}>
              <div className="row">
                <div className="col-xxl-9 col-xl-9 col-lg-12 col-md-12">
                  <div className="row g-1">
                    <div className="col-xxl-6 col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12">
                      <div className="filter_div border_div">
                        <Form.Group>
                          <div className="row g-1">
                            <div className="col-xxl-6 col-md-6 col-sm-6 col-12">
                              <Form.Label>Status:</Form.Label>
                              <Controller
                                control={control}
                                name="status_id"
                                render={({ field }) => (
                                  <Select
                                    {...field}
                                    options={
                                      all_management_system_required_status
                                    }
                                    placeholder="Select Status"
                                  />
                                )}
                              />
                            </div>

                            <div className="col-md-6 col-sm-6 col-6 mb-2">
                              <Form.Label>Name</Form.Label>
                              <Form.Control
                                type="test"
                                placeholder="Name"
                                {...register("name", {
                                  // required: "Transaction ID is required",
                                })}
                              />
                            </div>
                          </div>
                        </Form.Group>
                      </div>
                    </div>
                    <div className="col-xxl-6 col-xl-6 col-lg-8 col-md-8 col-sm-8 col-11">
                      <div className="filter_div ">
                        <Form.Group>
                          <div className="row g-1">
                            <div className="col-md-6 col-sm-6 col-6 mb-2">
                              <Form.Label>Start Date</Form.Label>
                              <Form.Control
                                type="date"
                                placeholder="Start Date"
                                {...register("start_date", {
                                  // required: "Transaction ID is required",
                                })}
                                onChange={(e) => {
                                  let value = e.target.value;
                                  const parts = value.split("-");

                                  if (parts[0] && parts[0].length > 4) {
                                    parts[0] = parts[0].slice(0, 4);
                                    e.target.value = parts.join("-");
                                  }
                                }}
                              />
                            </div>
                            <div className="col-md-6 col-sm-6 col-6">
                              <Form.Label>End Date</Form.Label>
                              <Form.Control
                                type="date"
                                placeholder="End Date"
                                {...register("end_date", {
                                  // required: "Transaction ID is required",
                                })}
                                onChange={(e) => {
                                  let value = e.target.value;
                                  const parts = value.split("-");

                                  if (parts[0] && parts[0].length > 4) {
                                    parts[0] = parts[0].slice(0, 4);
                                    e.target.value = parts.join("-");
                                  }
                                }}
                              />
                            </div>
                          </div>
                        </Form.Group>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-xxl-3 col-xl-3 col-lg-12 col-md-12">
                  <div className="btns_holder">
                    <Gray_Btn
                      btnText="Reset"
                      onClick={() => {
                        setSearchParams({
                          start_date: "",
                          end_date: "",
                          status_id: "",
                          name: "",
                        });
                        reset({
                          start_date: "",
                          end_date: "",
                          status_id: null,
                          name: "",
                        });
                      }}
                    />
                    <Black_Submit_Btn
                      type="submit"
                      btnText="Search"
                      // onClick={() => setSuccess(true)}
                    />
                  </div>
                </div>
              </div>
            </Form>
          </div>
        </div>
        <div className="col-lg-2 p-0">
          {haveDownloadPermission && (
            <div
              className="add_sample_div"
              onClick={() => reportgenerate("Risk Apportinities Report")}
            >
              <div className="add_img_div">
                <img
                  src="/assets/images/other/report.png"
                  className="add_img"
                />
              </div>
              <p className="inner_text">Generate Report</p>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default Filter;
